import React from 'react';
import PropTypes from 'prop-types';

import './FormGroup.css';

const classNames = (
  className,
  name,
  {
    vertical,
    inputWithIcon,
    inline,
    sideLabel,
  },
) => {
  const names = [];
  if (name) {
    names.push(name);
  }
  if (className) {
    names.push(className);
  }
  if (inline) {
    names.push('inline');
  }
  if (vertical) {
    names.push('vertical');
  }
  if (inputWithIcon) {
    names.push('inputWithIcon');
  }
  if (sideLabel) {
    names.push('sideLabel');
  }
  return names.join(' ');
};

const FormGroup = ({
  className,
  children,
  inline,
  vertical,
  sideLabel,
}) => (
  <div className={classNames(className, 'FormGroup', { inline, vertical, sideLabel })}>
    {children}
  </div>
);

FormGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  vertical: PropTypes.bool,
  inline: PropTypes.bool,
  sideLabel: PropTypes.bool,
};

FormGroup.defaultProps = {
  inline: false,
  vertical: false,
  sideLabel: false,
  className: '',
};

const InputGroup = ({ className, children, inputWithIcon }) => (
  <div className={classNames(className, 'InputGroup', { inputWithIcon })}>
    {children}
  </div>
);

InputGroup.propTypes = {
  className: PropTypes.string,
  inputWithIcon: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

InputGroup.defaultProps = {
  inputWithIcon: false,
  className: '',
};

FormGroup.InputGroup = InputGroup;

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/FormGroup.jsx